import React from "react";
import { useRef, useState, useEffect } from "react";
import "../styles/Content.css";
import "../styles/App.css";
import UltraHero from "../assets/image/ultra/UltraHero.webp";
import UltraLogo from "../assets/svg/logoUltra.svg";
import PrésentationVisuel1 from "../assets/image/ultra/visuel/PrésentaionVisuel1.webp";
import PrésentationVisuel2 from "../assets/image/ultra/visuel/PrésentaionVisuel2.webp";
import PrésentationVisuel3 from "../assets/image/ultra/visuel/PrésentaionVisuel3.webp";
import PrésentationVisuel4 from "../assets/image/ultra/visuel/PrésentaionVisuel4.webp";
import PrésentationVidéo from "../assets/image/ultra/visuel/PrésentaionVidéo.webp";
import PersonnalisationUltra from "../assets/image/ultra/PersonnalisationUltra.webp";
import Depliant from "../assets/svg/depliant.svg";
import CaracteristiqueUltra from "../assets/image/ultra/CaracteristiqueUltra.webp";
import PictoUltra from "../assets/svg/pictoUltra.svg";
import PictoBiosceau from "../assets/svg/PictoBiosceau.svg";
import PictoCouvercle from "../assets/svg/pictoCouvercle.svg";
import PictoSacAutoporte from "../assets/svg/pictoSacAutoporte.svg";
import PictoDimention from "../assets/svg/pictoDimention.svg";
import PictoInformation from "../assets/svg/information.svg";
import LogoClient1 from "../assets/image/logoClient/logoClient1.webp";
import LogoClient2 from "../assets/image/logoClient/logoClient2.webp";
import LogoClient3 from "../assets/image/logoClient/logoClient3.webp";
import LogoClient4 from "../assets/image/logoClient/logoClient4.webp";
import LogoClient5 from "../assets/image/logoClient/logoClient5.webp";
import LogoClient6 from "../assets/image/logoClient/logoClient6.webp";
import LogoClient7 from "../assets/image/logoClient/logoClient7.webp";
import LogoClient8 from "../assets/image/logoClient/logoClient8.webp";
import LogoClient9 from "../assets/image/logoClient/logoClient9.webp";
import LogoClient10 from "../assets/image/logoClient/logoClient10.webp";
import LogoClient11 from "../assets/image/logoClient/logoClient11.webp";
import LogoClient12 from "../assets/image/logoClient/logoClient12.webp";

export default function UltraPage() {
    const refPersonnalisation = useRef(null);
    const [expandedPersonnalisation, setExpandedPersonnalisation] =
        useState(false);
    const [preDevisOpen, setpreDevisOpen] = useState(false);
    const refPreDevis = useRef(null);
    const refClientsFormulaire = useRef(null);

    const scrollToClients = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        const el = refClientsFormulaire.current;
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const toggleSeoContentPersonnalisation = () => {
        const el = refPersonnalisation.current;
        if (!el) return;
        el.classList.toggle("show");
        const isShown = el.classList.contains("show");
        setExpandedPersonnalisation(isShown);
    };

    const lang = window.ULTRA_LANG?.code || "fr";

    const t = {
        fr: {
            heroTitle1: "La borne de tri métal",
            heroTitle2: "compacte et élégante",
            heroTitle3: "conçue avec les architectes",

            heroText:
                "Un design minimaliste, des matériaux nobles, une intégration parfaite dans les espaces les plus exigeants. Par Greenoffice, au service d’une architecture durable.",

            persoTitle1: "Personnalisez votre Ultra à votre style.",
            persoTitle2: "Vous l’imaginez. Nous la concevons.",

            persoText1:
                "Pensée pour les architectes et les entreprises, Ultra répond aux attentes de sens, de durabilité et de respect de l’environnement. Fabriquée en bois massif et en métal recyclé, équipée d’un sac textile réutilisable, elle associe matériaux nobles, fabrication responsable et design exigeant.",
            persoText2:
                "Avec ses lignes épurées et ses finitions haut de gamme, Ultra s’intègre discrètement dans les bureaux, halls et espaces modernes. Alliant élégance, performance et impact environnement positif, elle incarne une nouvelle génération de bornes de tri design au service d’une architecture durable et responsable.",

            buyUltra: "Acheter un collecteur Ultra",

            dimMobile: "Dimension",
            capaMobile: "Capacité 50 L",
            sacMobile1: "Sac",
            sacMobile2: "autoporté",
            bioseauMobile: "Bioseau",
            optionMobile: "En option",
            couvercleMobile1: "Couvercle",
            couvercleMobile2: "en plexiglass",

            caracteristiqueTitle1: "Caractéristiques du produit",
            caracteristiqueTitle2:
                "Une conception soignée jusque dans les moindres finitions",

            dim: "Dimension",
            capa: "Capacité 50 L",
            sac1: "Sac",
            sac2: "autoporté",
            bioseau: "Bioseau",
            couvercle1: "Couvercle",
            couvercle2: "en plexiglass",
            option: "En option",

            predTitle1: "Du savoir-faire à l’impact :",
            predTitle2: "Quand le tri devient une pièce d’artisanat",

            predText:
                "Ultra est une borne de tri durable et responsable, conçue avec des artisans engagés qui partagent une exigence de qualité et de respect de l’environnement. Alliant esthétique et éthique, elle incarne un design responsable au service d’espaces professionnels élégants et durables.",

            demandeDevis: "Demander un devis",
            reponseRapide: "Réponse rapide et sans engagement",
        },
        en: {
            heroTitle1: "The metal waste bin",
            heroTitle2: "compact and elegant",
            heroTitle3: "designed with architects",

            heroText:
                "A minimalist design, noble materials and perfect integration into the most demanding spaces. By Greenoffice, serving sustainable architecture.",

            persoTitle1: "Customize your Ultra to match your style.",
            persoTitle2: "You imagine it. We create it.",

            persoText1:
                "Designed for architects and businesses, Ultra meets expectations of purpose, durability and environmental responsibility. Made from solid wood and recycled metal and equipped with a reusable textile bag, it combines noble materials, responsible manufacturing and refined design.",
            persoText2:
                "With its clean lines and premium finishes, Ultra blends discreetly into offices, lobbies and modern spaces. Combining elegance, performance and positive environmental impact, it represents a new generation of design recycling stations for sustainable architecture.",

            buyUltra: "Buy an Ultra collector",

            dimMobile: "Dimensions",
            capaMobile: "Capacity 50 L",
            sacMobile1: "Self-supporting",
            sacMobile2: "bag",
            bioseauMobile: "Bio bucket",
            optionMobile: "Optional",
            couvercleMobile1: "Lid",
            couvercleMobile2: "in plexiglass",

            caracteristiqueTitle1: "Product features",
            caracteristiqueTitle2:
                "A meticulous design down to the finest details",

            dim: "Dimensions",
            capa: "Capacity 50 L",
            sac1: "Self-supporting",
            sac2: "bag",
            bioseau: "Bio bucket",
            couvercle1: "Lid",
            couvercle2: "in plexiglass",
            option: "Optional",

            predTitle1: "From craftsmanship to impact:",
            predTitle2: "When sorting becomes a work of craftsmanship",

            predText:
                "Ultra is a durable and responsible recycling station, created with committed artisans who share a demand for quality and environmental respect. Combining aesthetics and ethics, it embodies responsible design for elegant and sustainable professional spaces.",

            demandeDevis: "Request a quote",
            reponseRapide: "Fast response, no commitment",
        },
        de: {
            heroTitle1: "Kompakte und elegante",
            heroTitle2: "Metall-Wertstoffstation",
            heroTitle3: "entwickelt mit Architekten",

            heroText:
                "Ein minimalistisches Design, hochwertige Materialien, perfekt integriert in die anspruchsvollsten Räume. Von Greenoffice – im Dienste einer nachhaltigen Architektur.",

            persoTitle1: "Gestalten Sie Ihr Ultra nach Ihrem Stil.",
            persoTitle2: "Sie stellen es sich vor - wir realisieren es.",

            persoText1:
                "Ultra wurde für die Anforderungen der Architekten und Unternehmen entwickelt und erfüllt dessen Sinnhaftigkeit, Langlebigkeit und Umweltverträglichkeit. Hergestellt aus massivem Holz und recyceltem Metall, ausgestattet mit einem wiederverwendbaren Textilsack, vereint er hochwertige Materialien, verantwortungsvolle Fertigung und anspruchsvolles Design. Ultra ist weit mehr als eine Wertstoffstation – sie ist ein echtes Engagement für die anspruchsvollsten professionellen und architektonischen Räume.",
            persoText2:
                "Mit ihren klaren Linien und hochwertigen Oberflächen fügt sich Ultra unauffällig in Büros, Eingangsbereiche und moderne Räume ein. Eleganz, Leistung und positiver Umwelteinfluss vereint, repräsentiert sie eine neue Generation von Design-Wertstoffstationen im Dienste nachhaltiger und verantwortungsvoller Architektur.",

            buyUltra: "Ultra Collector kaufen",

            dimMobile: "Abmessungen: ",
            capaMobile: "Kapazität: 50 L",
            sacMobile1: "Selbsttragender",
            sacMobile2: "Sack",
            bioseauMobile: "Bio-Eimer",
            optionMobile: "Als Option.",
            couvercleMobile1: "Deckel",
            couvercleMobile2: "aus Plexiglas",

            caracteristiqueTitle1: "Produkteigenschaften:",
            caracteristiqueTitle2:
                "Sorgfältiges Design bis ins kleinste Detail",

            dim: "Abmessungen:",
            capa: "Kapazität: 50 L",
            sac1: "Selbsttragender",
            sac2: "Sack",
            bioseau: "Bio-Eimer",
            couvercle1: "Deckel",
            couvercle2: "aus Plexiglas",
            option: "Als Option.",

            predTitle1: "Von Handwerk zu Wirkung:",
            predTitle2: "Wenn Recycling zu einem Kunsthandwerk wird",

            predText:
                "Ultra ist eine nachhaltige und verantwortungsbewusste Wertstoffstation, entwickelt mit engagierten Handwerkern, die Qualität und Umweltbewusstsein teilen. Ästhetik und Ethik vereint, steht sie für verantwortungsvolles Design in eleganten und nachhaltigen Arbeitsräumen.",

            demandeDevis: "Angebot anfordern",
            reponseRapide: "Schnelle Antwort, unverbindlich",
        },
    }[lang];

    // Ouvre le bloc quand 50% de la section est visible,
    // et le referme sinon (y compris apres depassement)
    useEffect(() => {
        const el = refPreDevis.current;
        if (!el) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                const ratio = entry.intersectionRatio;
                if (ratio >= 0.5) {
                    // ouvert =>ajouter la classe .is-open (state false)
                    setpreDevisOpen(true);
                }
            },
            { threshold: [0, 0.5, 1] }
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    const cols = [
        [LogoClient1, LogoClient2, LogoClient3, LogoClient4],
        [LogoClient5, LogoClient6, LogoClient7, LogoClient8],
        [LogoClient9, LogoClient10, LogoClient11, LogoClient12],
    ];

    const formHtml = window.ULTRA_FORM?.html || "";

    return (
        <div className="ultra-page">
            {/* Hero Section */}
            <section className="hero">
                <div className="hero-image">
                    <img
                        src={UltraLogo}
                        loading="eager"
                        alt="Logo de la poubelle Ultra"
                        className="logoUltraMobile"
                    />
                    <img
                        src={UltraHero}
                        alt="Poubelle Ultra vue de près, personnalisation en bois et métal"
                        loading="eager"
                        className="hero-ultra-image"
                    />
                </div>

                <div className="hero-content">
                    <img
                        src={UltraLogo}
                        loading="eager"
                        alt="Logo de la poubelle Ultra"
                        className="logoUltraPC"
                    />

                    <h1>
                        {t.heroTitle1}
                        <br /> {t.heroTitle2}
                        <br /> {t.heroTitle3}
                    </h1>
                    <p>{t.heroText}</p>
                </div>
            </section>

            {/* Section Visuel présentation */}
            <section className="presentation">
                <img loading="lazy" src={PrésentationVisuel1} alt="" />
                <img loading="lazy" src={PrésentationVisuel2} alt="" />
                <img loading="lazy" src={PrésentationVisuel3} alt="" />
                <img loading="lazy" src={PrésentationVisuel4} alt="" />
                <img loading="lazy" src={PrésentationVidéo} alt="" />
            </section>

            {/* Section Personnalisation */}
            <section className="personnalisation">
                <div>
                    <h2>
                        {t.persoTitle1} <br />
                        <span>{t.persoTitle2}</span>
                    </h2>
                    <p>{t.persoText1}</p>
                    <p
                        id="seo-content-personnalisation"
                        ref={refPersonnalisation}
                        className="SeoContent"
                    >
                        {t.persoText2}
                    </p>
                    <button
                        type="button"
                        onClick={toggleSeoContentPersonnalisation}
                        aria-controls="seo-content-personnalisation"
                        aria-expanded={expandedPersonnalisation}
                        className="depliantPersonnalisation"
                    >
                        <img src={Depliant} alt="" aria-hidden="true" />
                    </button>
                    <a href="#clientsFormulaire" onClick={scrollToClients}>
                        {t.buyUltra}
                    </a>
                </div>
                <img
                    loading="lazy"
                    src={PersonnalisationUltra}
                    className="PersonnalisationUltra"
                    alt=""
                />
            </section>

            {/*Caractéristique*/}
            <section className="caracteristiques">
                <div className="caracteristiqueListeMobile">
                    <ul>
                        <li>
                            <img src={PictoUltra} alt="" /> <br />
                            {t.capaMobile}
                        </li>
                        <li>
                            <img src={PictoDimention} alt="" /> <br />
                            {t.dimMobile} <br /> 30 x 30 x 88 cm
                        </li>
                        <li>
                            <img src={PictoSacAutoporte} alt="" /> <br />
                            {t.sacMobile1} <br /> {t.sacMobile2}
                        </li>
                        <li>
                            <img src={PictoBiosceau} alt="" /> <br />
                            {t.bioseauMobile}
                            <button
                                className="info"
                                tabIndex="0"
                                aria-label="En option"
                            >
                                <img
                                    src={PictoInformation}
                                    className="InformationLogo"
                                    alt=""
                                />
                                <span className="info-tooltip" role="tooltip">
                                    {t.optionMobile}
                                </span>
                            </button>
                        </li>
                        <li>
                            <img src={PictoCouvercle} alt="" /> <br />
                            {t.couvercleMobile1}
                            <span
                                className="info"
                                role="button"
                                tabIndex="0"
                                aria-label="En option"
                            >
                                <img
                                    src={PictoInformation}
                                    className="InformationLogo"
                                    alt=""
                                />
                                <span className="info-tooltip" role="tooltip">
                                    {t.optionMobile}
                                </span>
                            </span>{" "}
                            <br />
                            {t.couvercleMobile2}
                        </li>
                    </ul>
                </div>
                <img
                    loading="lazy"
                    src={CaracteristiqueUltra}
                    className="UltraOuverte"
                    alt=""
                />

                <div className="caracteristiqueContent">
                    <h2>
                        {t.caracteristiqueTitle1}
                        <br />
                        <span>{t.caracteristiqueTitle2}</span>
                    </h2>
                    <div className="caracteristiqueListePC">
                        <ul>
                            <li>
                                <img src={PictoUltra} alt="" /> <br />
                                {t.capa}
                            </li>
                            <li>
                                <img src={PictoDimention} alt="" /> <br />
                                {t.dim} <br /> 30 x 30 x 88 cm
                            </li>
                            <li>
                                <img src={PictoSacAutoporte} alt="" /> <br />
                                {t.sac1} <br /> {t.sac2}
                            </li>
                            <li>
                                <img src={PictoBiosceau} alt="" /> <br />
                                {t.bioseau}
                                <button
                                    className="info"
                                    tabIndex="0"
                                    aria-label="En option"
                                >
                                    <img
                                        src={PictoInformation}
                                        className="InformationLogo"
                                        alt=""
                                    />
                                    <span
                                        className="info-tooltip"
                                        role="tooltip"
                                    >
                                        {t.option}
                                    </span>
                                </button>
                            </li>
                            <li>
                                <img src={PictoCouvercle} alt="" /> <br />
                                {t.couvercle1}
                                <span
                                    className="info"
                                    role="button"
                                    tabIndex="0"
                                    aria-label="En option"
                                >
                                    <img
                                        src={PictoInformation}
                                        className="InformationLogo"
                                        alt=""
                                    />
                                    <span
                                        className="info-tooltip"
                                        role="tooltip"
                                    >
                                        {t.option}
                                    </span>
                                </span>{" "}
                                <br />
                                {t.couvercle2}
                            </li>
                        </ul>
                    </div>
                </div>
            </section>

            {/*Prédement de devis*/}
            <section ref={refPreDevis} className="preDemandeDeDevis">
                <div
                    className={
                        "preDemandeDeDevisBlock" +
                        (preDevisOpen ? "" : " is-open")
                    }
                >
                    <button
                        type="button"
                        className="depliantPreDemandeDeDevis"
                        onClick={() => setpreDevisOpen((v) => !v)}
                        aria-pressed={preDevisOpen}
                        aria-controls="preDevisContent"
                    >
                        <img src={Depliant} alt="" aria-hidden="true" />
                    </button>
                    <div className="preDemandeDeDevisContent">
                        <h2>
                            {t.predTitle1}
                            <br />
                            <span>{t.predTitle2}</span>
                        </h2>
                        <p>{t.predText}</p>
                        <button
                            className="cta"
                            aria-describedby="cta-note"
                            onClick={scrollToClients}
                        >
                            {t.demandeDevis}
                            <span>{t.reponseRapide}</span>
                        </button>
                    </div>
                </div>
            </section>

            {/* Section Logos Clients */}
            <section
                className="clientsFormulaire"
                id="clientsFormulaire"
                ref={refClientsFormulaire}
            >
                <div className="client">
                    {cols.map((col, i) => (
                        <div key={i}>
                            {[...col, ...col].map((logo, j) => (
                                <div
                                    className={`card card-${(j % 4) + 1}`}
                                    key={j}
                                >
                                    <img
                                        src={logo}
                                        alt=""
                                        loading="lazy"
                                        decoding="async"
                                    />
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
                <div className="separation"></div>
                <div
                    className="formulaire"
                    dangerouslySetInnerHTML={{ __html: formHtml }}
                ></div>
            </section>
        </div>
    );
}
